import Image from "next/image"
import Link from "next/link"
import styles from "../../styles/components/blogs/AuthorCard.module.css"
import { replaceImageUrl } from "../../utils/helpers/imageUtils"

export default function AuthorCard({ author }) {
  if (!author) return null

  const blogCount = author?.blogs?.length || 0
  const hasExpertises = author?.expertises && author?.expertises?.length > 0
  const expertiseCount = hasExpertises ? author?.expertises?.length || 0 : 0

  return (
    <article className={styles.authorCard}>
      <Link href={`/author/${author?.slug || ''}`} className={styles.cardLink}>
        {/* Card Header with Image */}
        <div className={styles.cardHeader}>
          <div className={styles.authorImageWrapper}>
            <div className={styles.imageBorder}></div>
            <div className={styles.authorImageContainer}>
              {author?.image?.url ? (
                <Image
                  src={replaceImageUrl(author?.image?.url)}
                  alt={author?.image?.alternativeText || author?.name || 'Author'}
                  width={200}
                  height={200}
                  className={styles.authorImage}
                  priority={false}
                />
              ) : (
                <div className={styles.placeholderImage}>
                  <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                </div>
              )}
            </div>
            <div className={styles.imageOverlay}></div>
          </div>
        </div>

        {/* Card Body */}
        <div className={styles.cardBody}>
          <div className={styles.authorInfo}>
            <h3 className={styles.authorName}>{author?.name || 'Author'}</h3>
            
            {author?.about && (
              <p className={styles.authorBio}>
                {author?.about?.length > 140 ? `${author?.about?.substring(0, 140)}...` : author?.about}
              </p>
            )}

            {/* Expertise Tags */}
            {hasExpertises && (
              <div className={styles.expertiseSection}>
                <div className={styles.expertiseHeader}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 2L2 7l10 5 10-5-10-5z" />
                    <path d="M2 17l10 5 10-5M2 12l10 5 10-5" />
                  </svg>
                  <span className={styles.expertiseLabel}>Expertise</span>
                </div>
                <div className={styles.expertiseTags}>
                  {author?.expertises?.slice(0, 4).map((expertise, index) => (
                    <span key={index} className={styles.expertiseTag}>
                      {expertise}
                    </span>
                  ))}
                  {expertiseCount > 4 && (
                    <span className={styles.expertiseTagMore}>
                      +{expertiseCount - 4}
                    </span>
                  )}
                </div>
              </div>
            )}
          </div>

          {/* Card Footer with Stats */}
          <div className={styles.cardFooter}>
            <div className={styles.authorStats}>
              <div className={styles.statItem}>
                <div className={styles.statIcon}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
                    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
                  </svg>
                </div>
                <div className={styles.statContent}>
                  <span className={styles.statValue}>{blogCount}</span>
                  <span className={styles.statLabel}>{blogCount === 1 ? 'Article' : 'Articles'}</span>
                </div>
              </div>
              {hasExpertises && (
                <div className={styles.statItem}>
                  <div className={styles.statIcon}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M12 2L2 7l10 5 10-5-10-5z" />
                      <path d="M2 17l10 5 10-5M2 12l10 5 10-5" />
                    </svg>
                  </div>
                  <div className={styles.statContent}>
                    <span className={styles.statValue}>{expertiseCount}</span>
                    <span className={styles.statLabel}>Topics</span>
                  </div>
                </div>
              )}
            </div>
            <div className={styles.viewProfile}>
              <span>View Profile</span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </div>
          </div>
        </div>

        {/* Hover Effect Overlay */}
        <div className={styles.cardHoverOverlay}></div>
      </Link>
    </article>
  )
}

